var DiagnosticsConstants: IDiagnosticsConstants = {
    GET_DATA: 'GET_DATA',
    GET_NEXT_DATA: 'GET_NEXT_DATA',
    GET_AUDIT_DATA: 'GET_AUDIT_DATA',
    GET_NEXT_AUDIT_DATA: 'GET_NEXT_AUDIT_DATA',
    GET_CSV: 'GET_CSV',
    DISPLAY_DIAGNOSTICS: 'DISPLAY_DIAGNOSTICS',
    CLOSE_DIAGNOSTICS: 'CLOSE_DIAGNOSTICS',
    EXPORT_TO_CSV: 'EXPORT_TO_CSV'
} as const;

export default DiagnosticsConstants;
